import React from 'react';
import { connect } from 'react-redux';
import { colors } from '../../../constants';
import { isDefined } from '../../../utils';

class CoachingSummery extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        const
            {
                coachingSummary,
                jibeSessions
            } = this.props;
        if (!isDefined(coachingSummary))// || !Array.isArray(surveySummery) || surveySummery.length < 1)
            return <div></div>

        let surveySummery = [
            {
                text: "All Agents",
                barColor: colors.secandary200,
                number: coachingSummary.totalAgentsCount,
            },
            {
                text: "Coached Agents",
                barColor: colors.primary200,
                number: coachingSummary.coachedAgentsCount,
                rate: `(32%)`,
            }
        ];

        const max = surveySummery[0].number;

        const summery = surveySummery.map((res, index) => {

            const backgroundColor = `repeating-linear-gradient(45deg,  ${res.barColor},  ${res.barColor} 8px , rgb(237, 239, 248),rgb(237, 239, 248) 10px)`
            const widthPercentage = `${(res.number * 70) / max}%`
            return (<div key={index} style={{ marginBottom: '10px' }} className="flex-container-start">
                <div className="SurveyCountSummery-text flex-container-end" style={{ fontSize: '16px' }}>{res.text}</div>
                <div className="SurveyCountSummery-bar"
                    style={{ background: backgroundColor, width: widthPercentage }}></div>
                <div style={{ marginRight: '10px' }} >{res.number}</div>
                {isDefined(res.rate) && <div style={{ color: 'gray', marginRight: '5px' }}>{res.rate}</div>}
            </div>)
        });

        return <div className="system-dashboard-jibe-border SurveyCountSummery-main"
            style={{ backgroundImage: `url(${`../../../../../Assets/Images/V3Design/profileAgentNoAvatar.png`})` }}>
            <div className="flex-container" style={{ minHeight: '38px', borderBottom: '1px solid #E6F7F8', }}>
                <div className="title-primary-400-24-28">
                    Coaching Summary
                </div>
            </div>
            <div className="flex-container-start-align-start" style={{ marginTop: '15px' }}>
                <div style={{ width: '70%' }}>
                    {summery}
                </div>
                <div className="flex-container-start" style={{ marginRight: '75px' }} >
                    <div>
                        <div className="flex-container-start" style={{ flexDirection: 'column' }}>
                            <div className="SurveyCountSummery-time">{coachingSummary.coachingSessionCount}</div>
                            <div style={{ justifyContent: 'center', fontSize: '16px' }}>
                                Coaching Sessions
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

const select = state => ({});

export default connect(select)(CoachingSummery);
